export const WEB_SERVICES = {
  GET_HORIZONTAL_ADDRESS: 'GET_HORIZONTAL_ADDRESS',
  GET_VERTICAL_ADDRESS: 'GET_VERTICAL_ADDRESS',
  GET_ADDRESS_BY_ID: 'GET_ADDRESS_BY_ID',
  GET_EMPLOYEES_PRODUCTS: 'GET_EMPLOYEES_PRODUCTS',
  GET_MY_DATA: 'GET_MY_DATA',
  GET_MY_PRODUCTS: 'GET_MY_PRODUCTS',
  GET_MY_LINES: 'GET_MY_LINES',
  GET_MY_PRODUCT_DETAILS: 'GET_MY_PRODUCT_DETAILS',
  GET_MY_CONTACTS: 'GET_MY_CONTACTS',
  ALLOW_ADVERTISING_USE: 'ALLOW_ADVERTISING_USE',
  GET_RESOURCES: 'CQV2.GET_RESOURCES',
  SELECT_RESOURCES: 'CQV2.SELECT_RESOURCES',
  CHECK_NETFLIX: 'CHECK_NETFLIX',
  GET_NEXT_STEPS: 'GET_NEXT_STEPS',
  INIT_CQ: 'CQV2.INIT_CQ',
  INIT_CQ_AFTER_SALE : 'CQV2.INIT_CQ_AFTER_SALE',
  INIT_CQ_TV : 'CQV2.INIT_CQ_TV',
  SELECT_ELEMENTS: 'CQV2.SELECT_ELEMENTS',
  GET_FEATURES: 'CQV2.GET_FEATURES',
  ADD_ITEMS_TO_CART: 'CQV2.ADD_TO_CART',
  EXTEND_CQ: 'CQV2.EXTEND_CQ',
  EXTEND_CQ_AFTER_SALE: 'CQV2.EXTEND_CQ_AFTER_SALE',
  EXTEND_CQ_TV: 'CQV2.EXTEND_CQ_TV',
  GET_POTS: 'CQV2.GET_POTS',
  GET_PROVISIONAL_AGREEMENT: 'CQV2.GET_PROVISIONAL_AGREEMENT',
  UPDATE_CQ: 'CQV2.UPDATE_CQ',
  UPDATE_CA: 'CQV2.UPDATE_CA',
  GET_CQ_PRICES: 'CQV2.GET_CQ_PRICES',
  GET_LEGAL_TERMS: 'CQV2.GET_LEGAL_TERMS',
  GET_FIRMA_OTP: 'GET_FIRMA_OTP',
  CONFIRM_CQ: 'CQV2.CONFIRM_CQ',
  CANCEL_CQ: 'CQV2.CANCEL_CQ',
  GET_FILTER_CUSTOMER_PRODUCT_TO_HIRE_ACTIONS:
        'CQV2.GET_FILTER_CUSTOMER_PRODUCT_TO_HIRE_ACTIONS',
  GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING:
        'CQV2.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING',
  GET_SELLING_TYPES_BY_PRODUCT_ID: 'CQV2.GET_SELLING_TYPES_BY_PRODUCT_ID',
  UPDATE_MY_CONTACTS: 'UPDATE_MY_CONTACTS',
  SHIPPING_TO_SE: 'SHIPPING_TO_SE',
  GENERATE_PIN: 'GENERATE_PIN',
  CHECK_PIN: 'CHECK_PIN',
  GET_CATALOG_SECTIONS: 'GET_CATALOG_SECTIONS',
  GET_PRODUCT_OFFERING: 'GET_PRODUCT_OFFERING',
  GET_PRODUCT_OFFERING_ORION: 'GET_PRODUCT_OFFERING_ORION',
  GET_SHOPPER_DATA: 'GET_SHOPPER_DATA',
  REGISTER_SHOPPER: 'REGISTER_SHOPPER',
  VALIDATE_SHOPPER: 'VALIDATE_SHOPPER',
  IS_REGISTERED_SHOPPER: 'IS_REGISTERED_SHOPPER',
  DELETE_SHOPPER: 'DELETE_SHOPPER',
  GET_MOBILE_INSURANCE: 'GET_MOBILE_INSURANCE',
  CHECK_SCANNED_DOCUMENT: 'CHECK_SCANNED_DOCUMENT',
  GET_POSSIBLE_ISR: 'CQV2.GET_POSSIBLE_ISR',
  GET_PRODUCT_OFFERING_ALL_INFO: 'GET_PRODUCT_OFFERING_ALL_INFO',
  SEND_STATUS: 'TECALIS.SEND_STATUS',
  UPDATE_PERMANENT_RESIDENCE: 'CLIENT.UPDATE_PERMANENT_RESIDENCE',
  MANAGER_GET_INFO: 'MANAGER.GET_INFO',
  GET_PRODUCT_EVALUATERULES: 'PAC.GET_PRODUCT_EVALUATERULES',
  DISAGREGATE_PRODUCT: 'CATALOG.DISAGREGATE_PRODUCT',
  GET_BIFURCAR: 'CATALOG.GET_BIFURCAR',
  GET_COVERAGE: 'CATALOG.GET_COVERAGE',
  DECREASE_STOCK: 'PAC.DECREASE_STOCK',
  CUSTOMIZER_ACTIVITY_GET_BY_NAME: 'CUSTOMIZER.ACTIVITY.GETBYNAME',
  GET_TERMINALS: 'PAC.GET_TERMINALS',
  GET_ALL_ITEM: 'PAC.TERMINAL.GET_ALL_ITEM',
  GET_CARD_PAYMENT_ERROR: 'GET_CARD_PAYMENT_ERROR',
  INIT_CARD_PAYMENT: 'INIT_CARD_PAYMENT',
  INIT_FUNDED_PAYMENT: 'INIT_FUNDED_PAYMENT',
  CHECK_FINANCED_PAYMENT_STATUS: 'CHECK_FINANCED_PAYMENT_STATUS',
  IS_R2R_AVAILABLE_TO_PURCHASE: 'IS_R2R_AVAILABLE_TO_PURCHASE',
  R2R_COMPATIBLE: 'R2R_COMPATIBLE',
  GET_SIGNATURE_OTP: 'GET_SIGNATURE_OTP',
  GET_FTTR_AVAILABILITY: 'GET_FTTR_AVAILABILITY',
  SEND_RETARGETING: 'SEND_RETARGETING',
  REDEEM_CAMPAIGN: 'REDEEM_CAMPAIGN',
  PIN_GENERATE: 'MANAGER.PIN_GENERATE',
  PIN_VALIDATE: 'MANAGER.PIN_VALIDATE',
  GET_CURRENT_DATE: 'GEO.GET_CURRENT_DATE',
  GET_RISK: 'GET_RISK',
  GET_AVAILABLE_EQUIPMENT: 'GET_AVAILABLE_EQUIPMENT',
};
